import { defineStore } from 'pinia'
import { useEzioAPI } from '@ezio/services'

export const useSearchStore = defineStore('search', () => {
    const { api } = useEzioAPI()

    const search = async (query: string, types: string[]) => {
        const response = await api.get('search', {
            q: query,
            types: types.join(',')
        })
        return response.data
    }

    return { search }
})
